import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SchemaRouteStationInfo } from "../../project-schema/shared/interfaces/schema-route-station-info.interface";
import { DigitaleOutputs } from "../shared/interfaces/digitale-outputs.interface";
import { ProjectRouteStation } from "../../shared/interfaces/project-route-station.interface";
import { AlertTypes } from "../../../shared/alert/shared/alert-types";
import { StmService } from "../../shared/services/stm.service";
import { AlertService } from "../../../shared/alert/shared/alert.service";

@Component({
  selector: 'avs-test-area-digital-outputs',
  templateUrl: './test-area-digital-outputs.component.html',
  styleUrls: ['./test-area-digital-outputs.component.css']
})
export class TestAreaDigitalOutputsComponent implements OnChanges {
  @Input() schemaInfo: SchemaRouteStationInfo | undefined
  @Input() activeStation?: ProjectRouteStation

  public isAnyValueChanged: boolean = false;
  public isOnline: boolean = true;

  public digitalOneFound: boolean = false;
  public digitalOneChecked: boolean = false;
  public digitalTwoFound: boolean = false;
  public digitalTwoChecked: boolean = false;
  public radarFound: boolean = false;
  public radarChecked: boolean = false;
  public annaFound: boolean = false;
  public annaChecked: boolean = false;

  constructor(private stmService: StmService,
    private alertService: AlertService) { }

  public ngOnChanges(changes: SimpleChanges): void {
    this.digitalOneFound = false;
    this.digitalOneChecked = false;
    this.digitalTwoFound = false;
    this.digitalTwoChecked = false;
    this.radarFound = false;
    this.radarChecked = false;
    this.annaFound = false;
    this.annaChecked = false;

    this.schemaInfo?.digitalIOs?.forEach((io) => {
      if (io.cInfo.channel.de === 9) {
        this.annaFound = true;
        this.annaChecked = io.data?.activeStatus === true;
      }
      if (io.cInfo.channel.de === 6) {
        this.digitalOneFound = true;
        this.digitalOneChecked = io.data?.activeStatus === true;
      }
      if (io.cInfo.channel.de === 7) {
        this.digitalTwoFound = true;
        this.digitalTwoChecked = io.data?.activeStatus === true;
      }
      if (io.cInfo.channel.de === 8) {
        this.radarFound = true;
        this.radarChecked = io.data?.activeStatus === true;
      }
    })
  }

  public isParameterHigh(param: string) {
    if (param === 'high') {
      return true;
    } else {
      return false;
    }
  }

  public onDigitalOutputsToggleValueChange(channel: number, value: boolean): void {
    if (!this.activeStation) { return; }
    if (channel === 8) {
      this.stmService.setSensorPowerSwitch(channel.toString(), this.activeStation.samId, value).subscribe(() => {
        this.alertService.alert("Die Outputs wurden erfolgreich angesteuert", AlertTypes.info)
      });

    }
    if (channel === 9) {
      this.stmService.setLedSwitch(channel.toString(), this.activeStation.samId, value).subscribe(() => {
        this.alertService.alert("Die Outputs wurden erfolgreich angesteuert", AlertTypes.info)
      });
    }
    if (channel === 6 || channel === 7) {
      this.stmService.setDigitalOutput(channel.toString(), this.activeStation.samId, value).subscribe(() => {
        this.alertService.alert("Die Outputs wurden erfolgreich angesteuert", AlertTypes.info)
      });
      this.isAnyValueChanged = true;
    }
  }

}
